export class Media {
  id: number;
  name: string;
  ticketId: number | null;
  remark: string | null;
  uploadedBy: number;
  archived: boolean;
  fileInfo: FileInfo | null;
  contentType: string | null;
  extension: string | null;
  original: string | null;

  constructor(
    id: number = 0,
    name: string = "",
    ticketId: number = 0,
    remark: string | null = null,
    uploadedBy: number = 0,
    archived: boolean = false,
    fileInfo: FileInfo | null = null,
    contentType: string | null = null,
    extension: string | null = null,
    original: string | null = null
  ) {
    this.id = id;
    this.name = name;
    this.ticketId = ticketId;
    this.remark = remark;
    this.uploadedBy = uploadedBy;
    this.archived = archived;
    this.fileInfo = fileInfo;
    this.contentType = contentType;
    this.extension = extension;
    this.original = original;
  }
  public static get EMPTY(): Media {
    return new Media(0, "", 0, "", 0, false, null, null, null, null);
  }
}

export class FileInfo {
  section: string;
  path: string | null;
  fileName: string | null;
  byteSize: number | null;
  digested: Uint8Array | null;
  created: number | null;
  modified: number | null;

  constructor(
    section: string = "",
    path: string | null = null,
    fileName: string | null = null,
    byteSize: number | null = null,
    digested: Uint8Array | null = null,
    created: number | null = null,
    modified: number | null = null
  ) {
    this.section = section;
    this.path = path;
    this.fileName = fileName;
    this.byteSize = byteSize;
    this.digested = digested;
    this.created = created;
    this.modified = modified;
  }
}
